import React, { ReactNode } from 'react';
import classNames from 'classnames';

import CheckboxWidget, {
  Props as CheckboxWidgetProps,
} from 'components/UI/Form/Widget/CheckboxWidget/CheckboxWidget';
import Error from 'components/UI/Form/Error/Error';

export type Props = {
  label?: ReactNode;
  inputProps: CheckboxWidgetProps & { name: string };
  errorMessage?: string;
  classes?: {
    row?: string;
    rowError?: string;
    label?: string;
    labelError?: string;
    inputContainer?: string;
    inputRoot?: string;
    error?: string;
    icon?: string;
    checkedIcon?: string;
  };
  style?: React.CSSProperties;
};

export default function CheckboxRow({
  label,
  inputProps,
  errorMessage,
  classes,
  style,
}: Props): JSX.Element {
  const { id, name } = inputProps;

  return (
    <div className={classNames(classes?.row, classes?.rowError)} style={style}>
      {label && (
        <label
          htmlFor={id || name}
          className={classNames(classes?.label, classes?.labelError)}
        >
          {label}
        </label>
      )}
      <CheckboxWidget
        {...inputProps}
        classes={{
          inputContainer: classes?.inputContainer,
          inputRoot: classes?.inputRoot,
          icon: classes?.icon,
          checkedIcon: classes?.checkedIcon,
        }}
        id={id || name}
      />
      {errorMessage && <Error className={classes?.error}>{errorMessage}</Error>}
    </div>
  );
}
